import { render } from "./studioNews.vue?vue&type=template&id=b3a147ba&scoped=true"
import script from "./studioNews.vue?vue&type=script&lang=js"
export * from "./studioNews.vue?vue&type=script&lang=js"

import "./studioNews.vue?vue&type=style&index=0&id=b3a147ba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a147ba"]])

export default __exports__